import useData from './data-service'
import { Memories } from '../types/data-types'

export default function useMemories(): Memories | undefined {
  return useData()?.memories
}
